import script from "./UpdateView.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpdateView.vue?vue&type=script&lang=ts&setup=true"

import "./UpdateView.vue?vue&type=style&index=0&id=0c08fa09&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c08fa09"]])

export default __exports__